var React = require('react');

function S (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.664062 8.91997C0.664062 19.744 21.9161 16.939 21.9161 26.872C21.9161 30.535 18.1211 34.066 13.3031 34.066C5.4491 34.066 1.1261 26.212 1.1261 26.212H0.796021V30.634C3.23802 32.449 7.09908 34.66 11.4551 34.66C19.0781 34.66 23.8301 30.106 23.8301 25.519C23.8301 13.969 2.974 17.17 2.974 8.12797C2.974 4.46497 6.34009 0.735969 12.4781 0.735969C19.5401 0.735969 21.5531 6.27997 21.5531 6.27997H21.8831V1.85797C19.3421 0.999969 16.5371 0.339966 12.4781 0.339966C4.85509 0.339966 0.664062 4.33297 0.664062 8.91997Z","fill":"currentColor"}));
}

S.defaultProps = {"width":"24","height":"35","viewBox":"0 0 24 35","fill":"none"};

module.exports = S;

S.default = S;
